import { AlertTriangle, Bug, Info, XCircle } from "lucide-react";
import type { LogLevel } from "../../store/log-store";
import type { ThemeAccent } from "../../theme/runtime/theme-accents";

export const levelConfig: Record<
    LogLevel,
    { icon: typeof Info; accent: ThemeAccent; label: string }
> = {
    debug: { icon: Bug, accent: "muted", label: "DEBUG" },
    info: { icon: Info, accent: "info", label: "INFO" },
    warn: { icon: AlertTriangle, accent: "warning", label: "WARN" },
    error: { icon: XCircle, accent: "error", label: "ERROR" },
};

export function formatTime(iso: string): string {
    const d = new Date(iso);
    return (
        d.toLocaleTimeString("en-GB", {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }) +
        "." +
        String(d.getMilliseconds()).padStart(3, "0")
    );
}
